import { type PropsWithChildren, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Flex } from '@dynatrace/strato-components/layouts';
import { Text } from '@dynatrace/strato-components/typography';

import { emptyText } from './ChartState.sty.js';

/**
 * @internal
 */
export type EmptyStateProps = PropsWithChildren<{ height: string | number }>;

const EmptyStateTextWrapper = ({ height, children }: EmptyStateProps) => (
  <Flex justifyContent="center" alignItems="center" height={height}>
    <Text className={emptyText} textStyle="base">
      {children}
    </Text>
  </Flex>
);

/**
 * @internal
 */
export const EmptyState = ({ height, children }: EmptyStateProps) => {
  const messageNode: ReactNode = children || (
    <FormattedMessage
      id="VkfutNWZVq0loZNC"
      defaultMessage="No data available."
      description="Message to display when no data is available"
    />
  );

  return (
    <EmptyStateTextWrapper height={height}>{messageNode}</EmptyStateTextWrapper>
  );
};

EmptyState['displayName'] = 'EmptyState';
